import { RenewalType } from './renewalTableTileTypes';

export const formatRenewalType = (type: RenewalType) => {
    switch (type) {
        case RenewalType.RECOMMENDED:
            return 'recommended';
        case RenewalType.DONT_RENEW:
            return 'dontRenew';
        case RenewalType.CUSTOM:
            return 'custom';
        case RenewalType.SAME_AS_CURRENT_YEAR:
            return 'sameAsCurrentYear';
        default:
            return '';
    }
};
